module.exports = __webpack_public_path__ + "static/media/iop.0fe15abe.svg";